module.exports = __webpack_public_path__ + "media/feast.8b7913cb.mp4";